export default __webpack_public_path__ + "static/media/walletconnect.66f98648.svg";